import type { CustomFlowbiteTheme } from 'flowbite-react';

export const timelineTheme: CustomFlowbiteTheme['timeline'] = {
  root: {
    direction: {
      horizontal: 'items-base sm:flex',
      vertical: 'relative border-l border-titan-night-200',
    },
  },
  item: {
    root: {
      horizontal: 'relative mb-6 sm:mb-0',
      vertical: 'mb-10 ml-6',
    },
    content: {
      root: {
        base: 'mt-3 sm:pr-8',
      },
      body: {
        base: 'mb-4 text-base font-normal text-titan-night-500',
      },
      time: {
        base: 'mb-1 text-sm font-normal leading-none text-titan-night-400',
      },
      title: {
        base: 'text-lg font-semibold text-titan-night-900',
      },
    },
    point: {
      horizontal: 'flex items-center',
      line: 'hidden h-0.5 w-full bg-titan-night-200 sm:flex',
      marker: {
        base: {
          horizontal:
            'absolute -left-1.5 h-3 w-3 rounded-full border border-white bg-titan-night-200',
          vertical:
            'absolute -left-1.5 mt-1.5 h-3 w-3 rounded-full border border-white bg-titan-night-200',
        },
        icon: {
          base: 'h-3 w-3 text-titan-blue-600',
          wrapper:
            'absolute -left-3 flex h-6 w-6 items-center justify-center rounded-full bg-titan-blue-200 ring-8 ring-white',
        },
      },
      vertical: '',
    },
  },
};
